<template>
  <div>
    <v-modal x-short @open="fetchReactions">
      <template slot="#message-reactions">
        <div
          v-if="isLoading"
          class="d-flex justify-content-center text-muted mt-5 pt-5"
        >
          <v-loader />
        </div>
        <div v-else class="reactions__container d-flex flex-column">
          <action-header>
            Reactions
          </action-header>
          <action-body>
            <v-button
              v-if="selfReaction"
              secondary
              ghost
              @click="handleUnlike"
              class="d-flex justify-content-between align-items-center p-2 w-100"
            >
              <subscriber-avatar
                class="mr-2"
                :subscriber="selfReaction"
                small
              />
              <div class="d-flex flex-column justify-content-center name">
                You
                <div class="remove-description">
                  Tap to remove
                </div>
              </div>
              <div class="ml-auto">
                <v-icon icon="favorite" size="2rem" class="m-0"></v-icon>
              </div>
            </v-button>
            <div
              v-for="reaction in shownReactions"
              :key="reaction.id"
              class="d-flex justify-content-center align-items-center p-2"
            >
              <subscriber-avatar class="mr-2" :subscriber="reaction" small />

              <div class="name">
                {{ reaction.username }}
              </div>
              <div class="ml-auto">
                <v-icon icon="favorite" size="2rem"></v-icon>
              </div>
            </div>
          </action-body>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import SubscriberAvatar from "@/components/SubscriberAvatar"
import ActionHeader from "@/components/modals/shared/ActionHeader"
import ActionBody from "@/components/modals/shared/ActionBody"

export default {
  components: {
    SubscriberAvatar,
    ActionHeader,
    ActionBody
  },

  props: {
    ts: { type: [Number, String], required: true },
    messageThreadId: { type: [Number, String], required: true },
    actionHash: { type: String, require: true }
  },

  data() {
    return {
      isLoading: false,
      reactions: []
    }
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),

    selfReaction() {
      return (
        this.reactions.find(
          reaction => reaction.user_id === this.currentUser.id
        ) || null
      )
    },

    shownReactions() {
      return this.reactions.filter(
        reaction => reaction.user_id !== this.currentUser.id
      )
    }
  },

  methods: {
    ...mapActions("messages", ["fetchMessageReactions"]),

    fetchReactions() {
      this.isLoading = true

      this.fetchMessageReactions({
        messageThreadId: this.messageThreadId,
        messageTs: this.ts
      })
        .then(data => {
          this.reactions = data.reactions
        })
        .catch(err => console.log(err.response))
        .finally(() => {
          this.isLoading = false
        })
    },

    handleUnlike() {
      this.reactions = this.reactions.filter(
        reaction => reaction.user_id !== this.currentUser.id
      )

      this.$emit("react", "unlike")
      this.$router.removeHash()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

$icon--size: 40px;

.reactions__container {
  min-height: 40vh;

  .name {
    color: $color-ui--dark-blue;
    font-weight: bold;
  }

  .v-icon {
    transform: scale(1) !important;
    color: $color-ui--red !important;
  }

  .remove-description {
    font-size: 11px;
    color: $color-ui--grey-40;
  }
}
</style>
